import React, { PureComponent } from 'react';
import { Select } from 'antd';
import { indexOf, truncate } from 'lodash';
import PropTypes from 'prop-types';

const { Option } = Select;
export default class select extends PureComponent {
  render() {
    if (this.props.options) {
      return (
        <Select
          // muc dich su dung "props.name": xac dinh element theo dropdownClassName (auto test)
          dropdownClassName={`dropdown-${this.props.name}`}
          {...this.props}
          className={`'w-100' ${this.props.className}`}
          value={this.props.dataSelect && this.props.dataSelect.length ? this.props.value : undefined}
        >
          {this.props.dataSelect && this.props.dataSelect.map((item, i) => (
            <Option
              key={i}
              disabled={indexOf(this.props.dataDisable, item[this.props.options[0]]) !== -1}
              name={item[this.props.options[1]]}
              value={item[this.props.options[0]]}
            >
              {truncate(item[this.props.options[1]], { 'length': 70 })}
            </Option>
          ))}
        </Select>
      );
    }
    if (this.props.optionsChiTieu) {
      return (
        <Select
          // muc dich su dung "props.name": xac dinh element theo dropdownClassName (auto test)
          dropdownClassName={`dropdown-${this.props.name}`}
          {...this.props}
          className={`'w-100' ${this.props.className}`}
          value={this.props.dataSelect.length ? this.props.value : undefined}
        >
          {this.props.dataSelect.map((item, i) => (
            <Option
              key={i}
              disabled={indexOf(this.props.dataDisable, item[this.props.optionsChiTieu[0]]) !== -1}
              title={item[this.props.optionsChiTieu[1]]}
              name={item[this.props.optionsChiTieu[0]]}
              value={item[this.props.optionsChiTieu[0]]}
            >
              {truncate(item[this.props.optionsChiTieu[1]], { 'length': 60 })}
            </Option>
          ))}
        </Select>
      );
    }
    if (this.props.optionsForSearch) {
      return (
        <Select
          dropdownClassName={`dropdown-${this.props.name}`}
          {...this.props}
          className={`'w-100' ${this.props.className}`}
          value={this.props.dataSelect.length ? this.props.value : undefined}
        >
          {this.props.dataSelect.map((item, i) => (
            <Option
              key={i}
              disabled={indexOf(this.props.dataDisable, item[this.props.optionsForSearch[0]]) !== -1}
              name={(item[this.props.optionsForSearch[0]])}
              value={item[this.props.optionsForSearch[1]] + '|' + item[this.props.optionsForSearch[0]]}
            >
              {truncate(item[this.props.optionsForSearch[1]], { 'length': 1000 })}
            </Option>
          ))}
        </Select>
      );
    }
    return (
      <Select
        dropdownClassName={`dropdown-${this.props.name}`}
        {...this.props}
        className={`'w-100' ${this.props.className}`}
        value={this.props.dataSelect.length ? this.props.value : undefined}
      >
        {this.props.dataSelect.map((item, i) => (
          <Option
            key={i}
            disabled={indexOf(this.props.dataDisable, item.value) !== -1}
            name={item.name}
            value={item.value}
          >
            {item.name}
          </Option>
        ))}
      </Select>
    );
  }
}

select.propTypes = {
  dataDisable: PropTypes.arrayOf(PropTypes.any),
  dataSelect: PropTypes.arrayOf(PropTypes.any).isRequired,
  className: PropTypes.string,
  // moi element trong mot form se co "name" khac nhau
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.any),
  // eslint-disable-next-line react/require-default-props
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ])
};

select.defaultProps = {
  dataDisable: [],
  className: '',
  name: '',
  onChange: null,
  options: null
};
